import { ITransformActiveIndices } from '@components/data-transform-panel/store';
import { EStringOp } from '@src/emp-3.0/types';

export const getInitialActiveIndices = (): ITransformActiveIndices => ({
  orIndex: 0,
  metadataNameActive: false,
});

export const getEmptyTransformRuleItem = () => ({
  op: EStringOp.EQ,
  value: [],
});

export const getEmptyTransformRuleGroup = () => ({
  source_dimension: undefined,
  rule: [[getEmptyTransformRuleItem()]],
});
